import { OktaSignIn } from '../default';

// CDN bundle must have a single default export
export default OktaSignIn;
